import { datadogRum } from '@datadog/browser-rum';

import env from 'configs/env';

export function initRUM() {
  if (
    env.datadogApplicationId &&
    env.datadog &&
    env.environment &&
    typeof window !== 'undefined' &&
    !(window as Window).DD_RUM?.getInternalContext()
  ) {
    datadogRum.init({
      applicationId: env.datadogApplicationId,
      clientToken: env.datadog,
      site: 'datadoghq.com',
      service: 'nightowl-neo-web',
      env: env.environment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask',
      actionNameAttribute: 'id',
      version: import.meta.env.VITE_SOURCEMAP_VERSION,
    });

    datadogRum.startSessionReplayRecording();
  }
}
